import {MenuStrategy} from "../MenuStrategy";

export class ImpostazioniMenuStrategy extends MenuStrategy {
   constructor() {
    super('Impostazioni', '', '');
  }
}
